const route = "/employees";

export { route };
